"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M-.01 6.66l7.34 2 2 7.33 6.66-16z"];
//# sourceMappingURL=geolocation.js.map